/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/objects'
// Action Types

export const CHANGE_STATE = ReduxHelpers.Types.createActionType(
  prefix,
  'CHANGE_STATE'
)
export const CHANGE_DETAILS_STATE = ReduxHelpers.Types.createActionType(
  prefix,
  'CHANGE_DETAILS_STATE'
)

export const SUMMARY_SERVER_ERRORS = ReduxHelpers.Types.createActionType(
  prefix,
  'SUMMARY_SERVER_ERRORS'
)

export const DETAILS_SERVER_ERRORS = ReduxHelpers.Types.createActionType(
  prefix,
  'DETAILS_SERVER_ERRORS'
)

export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
export const REQUEST_PENDING_GRAPH = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING_GRAPH'
)
export const CLEANER_STAT = ReduxHelpers.Types.createActionType(
  prefix,
  'CLEANER_STAT'
)

export const DISPOSE_DETAILS = ReduxHelpers.Types.createActionType(
  prefix,
  'DISPOSE_DETAILS'
)
export const GET_OBJECTS_OVERVIEW_STATS_DATA =
  ReduxHelpers.Types.createActionType(prefix, 'GET_OBJECTS_OVERVIEW_STATS_DATA')
export const GET_OBJECT_DETAILS_STATS_DATA =
  ReduxHelpers.Types.createActionType(prefix, 'GET_OBJECT_DETAILS_STATS_DATA')
export const GET_OBJECT_DETAILS_TABLE_DATA =
  ReduxHelpers.Types.createActionType(prefix, 'GET_OBJECT_DETAILS_TABLE_DATA')
export const GET_OBJECT_DETAILS_GRAPH_DATA =
  ReduxHelpers.Types.createActionType(prefix, 'GET_OBJECT_DETAILS_GRAPH_DATA')
